const LottieSuccessAnimation = ({ jsonAnimation }) => {
  return (
    <lottie-player
      data-testid="mvfLottieSuccessAnimation"
      src={jsonAnimation}
      background="transparent"
      speed="1"
      style={{
        opacity: 0 /* invisible until setSuccessAnimationColourToMatchTheme runs */,
        height:
          '120px' /* just a default value set to the mid-point of all media queries */,
      }}
      autoplay
    />
  );
};

export default LottieSuccessAnimation;
